import { render, staticRenderFns } from "./NewsComponent.vue?vue&type=template&id=3bf54ee8&scoped=true&"
import script from "./NewsComponent.vue?vue&type=script&lang=js&"
export * from "./NewsComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewsComponent.vue?vue&type=style&index=0&id=3bf54ee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf54ee8",
  null
  
)

export default component.exports